import classnames from "classnames";
import React, { Fragment } from "react";

import styles from "./FieldRequestPreview.module.scss";
import FieldRequestPreviewHeader from "./FieldRequestPreviewHeader";

const FieldRequestPreview = ({
  displayName,
  isSubmitted,
  className,
  children,
}) => {
  return (
    <div className={classnames(styles.root, className)}>
      {isSubmitted ? (
        <Fragment>{children}</Fragment>
      ) : (
        <Fragment>
          <FieldRequestPreviewHeader
            empty
            label={displayName}
            value="No information provided"
          />
        </Fragment>
      )}
    </div>
  );
};

export default FieldRequestPreview;
